import Fade from './Fade';
import Slide from './Slide';
import Generic from './Generic';

const Animation = {
  Fade,
  Slide,
  Generic
};

export default Animation;
